import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useMergeState } from '../../../../irmlib/src/hooks'
import * as constants from '../../../../irmlib/src/common/constants'
import { defaultDateFormat } from '../../../../common/constants'
import { setBusy, clearBusy } from '../../../../irmlib/src/containers'
import { useTheme } from 'irmlib/styles'
import MuiDataTable from '../../../Controls/MuiDataTable'
import { Grid, Box, Typography } from '@mui/material'
import { Link, useHistory } from 'react-router-dom'
import { getUser } from '../../../../redux/global'
import { DateTime } from '../../../../irmlib/src/components/FormControls'
import { today, getMonth } from '../../../../irmlib/src/common'
import * as gdeTransactionsLite from '../../../../services/firestore/gdeTransactionsLite'
import * as routePaths from '../../../../navigation/routePaths'
import { CheckBox } from '../../../../irmlib/src/components/Controls'
import { totalNoOfBoxesForJob } from '../../../../services/common/appConstants'
import { useTranslation } from 'react-i18next'
import TopButtons from './TopButtons'


let loggedInUser

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
`

const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`
const initialState = {
  selectedData: [],
}

const MyjobpageData = (props) => {
  const [, setState, getState] = useMergeState(initialState)
  loggedInUser = getUser().workerId
  const value = props.FilterData
  const theme = useTheme()
  const { t } = useTranslation()
  const history = useHistory()
  const [myJobdata, setData] = React.useState([])

  const dataRet = async (val) => {
    const dataQuery = async (val, loggedInUser) => {
      setBusy()
      const collection = await gdeTransactionsLite.getQueryDataJob2(val, loggedInUser)
      const jobList = []
      collection.forEach((doc) => {
        const docData = doc.data()
        const assignedUserList = docData?.assignedUserList
        let totalNoOfBoxes = 0
        if (docData.totalBoxes === totalNoOfBoxesForJob) {
          totalNoOfBoxes = '-'
        } else {
          totalNoOfBoxes = parseInt(docData.totalBoxes)
        }

        if (val.createDateFrom !== constants.defaultSelect || val.createDateTo !== constants.defaultSelect || val.userName !== '--Select--' || loggedInUser) {
          let isValid = true
          const createDateJob = moment(docData.createdTs.seconds, 'X').format(defaultDateFormat)
          const createDateFromFilter = moment(val.createDateFrom).format(defaultDateFormat)
          const createDateToFilter = moment(val.createDateTo).format(defaultDateFormat)
          const convtCreateDateJob = new Date(createDateJob).getTime()
          const convtCreateDateFrom = new Date(createDateFromFilter).getTime()
          const convtCreateDateTo = new Date(createDateToFilter).getTime()
          if (val.createDateFrom !== constants.defaultSelect && val.createDateTo !== constants.defaultSelect) {
            if (convtCreateDateFrom > convtCreateDateJob || convtCreateDateTo < convtCreateDateJob) {
              isValid = false
            }
          } else if (val.createDateFrom !== constants.defaultSelect) {
            if (convtCreateDateFrom > convtCreateDateJob) {
              isValid = false
            }
          } else if (val.createDateTo !== constants.defaultSelect) {
            if (createDateToFilter < convtCreateDateJob) {
              isValid = false
            }
          }

          if (assignedUserList !== undefined) {
            let userId = val.userName
            if (userId === '--Select--') {
              userId = loggedInUser
            }

            if (!assignedUserList.includes(userId)) {
              isValid = false
            } 
          } else if (assignedUserList === undefined) {
            isValid = false
          }

          if (val.customer !== '' && val.customer !== constants.defaultSelect && val.customer.toUpperCase() !== docData.accountLevel1) {
            isValid = false
          }
          if (val.jobStatus !== constants.defaultSelect && val.jobStatus !== docData.jobStatus && !docData.jobStatus.search(',')) {
            isValid = false
          }
          if (val.districts.length > 1) {
            if (!val.districts.includes(docData.districtId)) {
              isValid = false
            }
          }
          if (val.deType !== constants.defaultSelect && val.deType !== docData.dataEntryType) {
            isValid = false
          }
          if (val.templateNAme !== constants.defaultSelect && val.templateNAme !== docData.templateName) {
            isValid = false
          }

          if (isValid) {
            jobList.push({
              jobId: doc.id,
              status: doc.data().jobStatus,
              status1: doc.data().jobStatus,
              boxes: totalNoOfBoxes,
              autoTransmit: (doc.data().autoTransmit === undefined) ? 'true' : doc.data().autoTransmit,
              manualTransmit: (doc.data().autoTransmit === undefined) ? 'false' : (doc.data().autoTransmit === 'true') ? 'false' : 'true',
              dateCreated: doc.data().createdTs ? moment(doc.data().createdTs.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
              boxesCompleted: doc.data().boxesCompleted ? doc.data().boxesCompleted : 0,
              targetDate: doc.data().targetDate ? moment(doc.data().targetDate.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
              orderNumber: doc.data().orderNumber,
              jobType: doc.data().dataEntryType,
              jobType1: doc.data().dataEntryType
            })
          }
        } else {
          jobList.push({
            jobId: doc.id,
            status: doc.data().jobStatus,
            status1: doc.data().jobStatus,
            boxes: totalNoOfBoxes,
            autoTransmit: (doc.data().autoTransmit === undefined) ? 'true' : doc.data().autoTransmit,
            manualTransmit: (doc.data().autoTransmit === undefined) ? 'false' : (doc.data().autoTransmit === 'true') ? 'false' : 'true',
            dateCreated: doc.data().createdTs ? moment(doc.data().createdTs.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
            boxesCompleted: doc.data().boxesCompleted ? doc.data().boxesCompleted : 0,
            targetDate: doc.data().targetDate ? moment(doc.data().targetDate.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
            orderNumber: doc.data().orderNumber,
            jobType: doc.data().dataEntryType,
            jobType1: doc.data().dataEntryType
          })
        }
      })
      setData(jobList)
      clearBusy()
      return jobList
    }
    return await dataQuery(val, loggedInUser)
  }

  const handleStatusFilterChange = () => {
    if (getState()?.selectedData.length !== 0) {
      history.push(`${routePaths.myJobs}`)
      setState({ selectedData: [] })  
    }
  }

  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet(value)
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching page data:', error)
      return []
    }
  }
  
  const columns = [
    { 
      label: t('tableColumns.jobId'), 
      name: 'jobId',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const rowdata = myJobdata[dataIndex]
          return (
            <JobLink id={`myJobs_jobLink_${rowdata?.jobId}`} theme={theme} to={{ pathname: `${routePaths.boxList}/${rowdata?.jobId}`, state: { fromAdmin: false } }}>
              {rowdata?.jobId}
            </JobLink>
          )
        }
      },
      filter: false, 
    }, 
    { 
      label: t('tableColumns.status'), 
      name: 'status',
      options: {
        filterType: 'multiselect',
      } 
    }, 
    { 
      label: t('tableColumns.dateCreated'),
      name: 'dateCreated',
      options: {
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <DateTime
              label= {t('tableColumns.dateCreated')}
              type='month'
              minDate={getMonth('2020-01')}
              maxDate= {getMonth(today())}
              onChange={(selectedMonth) => {
                const updatedFilterList = [...filterList]
                updatedFilterList[index] = selectedMonth ? [selectedMonth] : []
                onChange(updatedFilterList[index], index, column)
              }}
            />
          ),
          logic: (rowData, filterValue) => {
            if (filterValue && filterValue.length) {
              const filterMonth = filterValue[0]
              return !rowData.includes(filterMonth)
            } else {
              return false
            }
          }
        },
      },
    }, 
    { 
      label: t('tableColumns.boxes'), 
      name: 'boxes',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.boxesTransmitted'), 
      name: 'boxesCompleted',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.targetCompletionDate'), 
      name: 'targetDate',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.manualTransmit'), 
      name: 'manualTransmit',
      options: {
        filterType: 'dropdown',
        filterOptions: {
          names: [t('Search.Yes'), t('Search.No')],
          logic: (rowData, filterValue) => {
            if (filterValue[0] === t('Search.Yes')) {
              return rowData !== 'true'
            } else if (filterValue[0] === t('Search.No')) {
              return rowData !== 'false'
            } else {
              return false
            }
          }
        },
        customBodyRenderLite: (dataIndex) => {
          return (
            <CheckBox disabled checked={(myJobdata[dataIndex]?.manualTransmit === 'true')} />
          )
        }
      },
    },
    { 
      label: t('tableColumns.orderNumber'), 
      name: 'orderNumber',
      options: {
        filterType: 'textField',
      }
    },
    { 
      label: t('tableColumns.type'), 
      name: 'jobType'
    },
  ]

  const options = {
    filterType: 'dropdown',
    // selectableRows: 'single',
    selectableRowsHeader: false,
    selectToolbarPlacement: 'none',
    elevation: 0,
    page: 0,
    onFilterChange: handleStatusFilterChange,
    // sortOrder: {
    //   name: 'dateCreated',
    //   direction: 'desc'
    // },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      if (allRowsSelected.length === 0) {
        setState({ selectedData: [] })
      } else {
        // storing the rowdata of the jobs selected for transmission in selectedData
        const newSelectedData = allRowsSelected.map(row => {
          const rowData = myJobdata[row.dataIndex]
          return rowData
        })
        setState({ selectedData: newSelectedData })
      }
    },
  }
  return (
    <>
      <TableContainer>
        <Box boxShadow={3} borderRadius={4}>
          <Grid item container xs={12} md={12} sx={{ padding: '20px 20px 0px' }}>
            <Grid item container xs={12} md={4} alignItems={'center'}>
              <Typography variant='h6'>
                {t('routeTitles.myJobs')}
              </Typography>
            </Grid>
            <Grid item container xs={12} md={8} justifyContent="end">
              <TopButtons selectedData={getState().selectedData} id={'myJobs_topButtons'} />
            </Grid>
          </Grid>
          <MuiDataTable
            prop={props}
            data={getPageData}
            columns={columns}
            options={options}
      />
        </Box>
      </TableContainer>
      
    </>
  )
}
MyjobpageData.propTypes = {
  FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default MyjobpageData